const INITIAL_STATE = {
  recruiter: null,
};

module.exports = function RecruitmentReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'LOGOUT_SUCCESSFUL':
      return {
        ...INITIAL_STATE,
      };
    case 'SET_API_URL':
      return {
        ...INITIAL_STATE,
      };
    case 'SET_RECRUITER': {
      return {
        ...state,
        recruiter: action.recruiter,
      };
    }

    default: {
      return state;
    }
  }
};
